import React, { useState } from 'react';
import { User, AuthError } from 'firebase/auth';
import { signInWithGoogle } from '../utils/googleAuth';

type Props = {
  onSuccess?: (user: User) => void;
  onError?: (error: AuthError) => void;
  className?: string;
  label?: string;
};

const GoogleLoginButton: React.FC<Props> = ({
  onSuccess,
  onError,
  className = '',
  label = 'Google 계정으로 로그인',
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      const user = await signInWithGoogle();
      onSuccess?.(user);
    } catch (err: any) {
      console.log('[GoogleLoginButton] Google 로그인 에러:', err?.code, err?.message);
      const authErr = err as AuthError;
      if (
        authErr.code === 'auth/popup-closed-by-user' ||
        authErr.code === 'auth/cancelled-popup-request'
      ) {
        setError(null);
      } else if (authErr.code === 'auth/popup-blocked') {
        setError('팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.');
        onError?.(authErr);
      } else {
        setError(authErr.message || '로그인에 실패했습니다.');
        onError?.(authErr);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center gap-2">
      <button
        type="button"
        onClick={handleLogin}
        disabled={loading}
        className={
          `flex items-center justify-center gap-3 rounded-lg border border-gray-300 bg-white px-6 py-3 text-sm font-medium text-gray-700 shadow-sm transition hover:bg-gray-50 hover:shadow disabled:cursor-not-allowed disabled:opacity-60 ${className}`
        }
        aria-label={label}
      >
        <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" fill="#EA4335" />
        </svg>
        {loading ? '로그인 중...' : label}
      </button>
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default GoogleLoginButton;
